<div class="row px-2">
  <div class="col-md-12">
    <clr-datagrid>
      <clr-dg-column [clrDgField]="'startDate'">{{ 'reports.reportTable.dateStart' | translate }}</clr-dg-column>
      <clr-dg-column [clrDgField]="'site'">{{ 'reports.reportTable.site' | translate }}</clr-dg-column>
      <clr-dg-column [clrDgField]="'line'">{{ 'reports.reportTable.line' | translate }}</clr-dg-column>
      @if (isCpiSelected()) {
        <clr-dg-column [clrDgField]="'cpi'">CPI</clr-dg-column>
      }
      @if (isBpiSelected()) {
        <clr-dg-column [clrDgField]="'tpi'">TPI</clr-dg-column>
      }
      @if (isLpiSelected()) {
        <clr-dg-column [clrDgField]="'lpi'">LPI</clr-dg-column>
      }
      @if (isApiSelected()) {
        <clr-dg-column [clrDgField]="'api'">API</clr-dg-column>
      }
      @if (isChiSelected()) {
        <clr-dg-column [clrDgField]="'chi'">CHI</clr-dg-column>
      }
      <clr-dg-column [clrDgField]="'color'">{{ 'reports.reportTable.color' | translate }}</clr-dg-column>
      <clr-dg-column [clrDgField]="'product'">{{ 'reports.reportTable.product' | translate }}</clr-dg-column>
      <clr-dg-column [clrDgField]="'batch'">{{ 'reports.reportTable.batch' | translate }}</clr-dg-column>

      <!-- #586806 - Update KPI Report with CP & CPK columns -->
      @if (isCpCpkSelected()) {
        <clr-dg-column [matTooltip]="('abbr.cpTooltip' | translate)" [matTooltipPosition]="'above'">
          <div class="multi-line-header">
              <div class="cp-layout cp-header main-header">
                <span></span>
                <span></span>
                <span>Cp</span>
                <span></span>
                <span></span>
              </div>
              <div class="cp-layout sub-header">
                <span>Avg</span>
                <span> / </span>
                <span>Min</span>
                <span> / </span>
                <span>Geo</span>
              </div>
          </div>
        </clr-dg-column>
      }
      @if (isCpCpkSelected()) {
        <clr-dg-column [matTooltip]="('abbr.cpkTooltip' | translate)" [matTooltipPosition]="'above'">
          <div class="multi-line-header">
            <div class="cp-layout cp-header main-header">
              <span></span>
              <span></span>
              <span>Cpk</span>
              <span></span>
              <span></span>
            </div>
            <div class="cp-layout sub-header">
              <span>Avg</span>
              <span> / </span>
              <span>Min</span>
              <span> / </span>
              <span>Geo</span>
            </div>
          </div>
        </clr-dg-column>
      }

      <clr-dg-row *clrDgItems="let kpiReportDataset of kpiReportDatasets">
        <clr-dg-cell>{{ kpiReportDataset.startDate | dateFormat | async }}</clr-dg-cell>
        <clr-dg-cell>{{ kpiReportDataset.site }}</clr-dg-cell>
        <clr-dg-cell>{{ kpiReportDataset.line }}</clr-dg-cell>
        @if (isCpiSelected()) {
          <clr-dg-cell class="kpi {{ 'text-' | kpiLabel: kpiReportDataset.cpi?.kpiColor }}">
            {{ kpiReportDataset.cpi?.kpiValue }}
          </clr-dg-cell>
        }
        @if (isBpiSelected()) {
          <clr-dg-cell class="kpi {{ 'text-' | kpiLabel: kpiReportDataset.tpi?.kpiColor }}">
            {{ kpiReportDataset.tpi?.kpiValue }}
          </clr-dg-cell>
        }
        @if (isLpiSelected()) {
          <clr-dg-cell class="kpi {{ 'text-' | kpiLabel: kpiReportDataset.lpi?.kpiColor }}">
            {{ kpiReportDataset.lpi?.kpiValue }}
          </clr-dg-cell>
        }
        @if (isApiSelected()) {
          <clr-dg-cell class="kpi {{ 'text-' | kpiLabel: kpiReportDataset.api?.kpiColor }}">
            {{ kpiReportDataset.api?.kpiValue }}
          </clr-dg-cell>
        }
        @if (isChiSelected()) {
          <clr-dg-cell class="kpi {{ 'text-' | kpiLabel: kpiReportDataset.chi?.kpiColor }}">
            {{ kpiReportDataset.chi?.kpiValue }}
          </clr-dg-cell>
        }
        <clr-dg-cell>{{ kpiReportDataset.color }}</clr-dg-cell>
        <clr-dg-cell>{{ kpiReportDataset.product }}</clr-dg-cell>
        <clr-dg-cell>{{ kpiReportDataset.batch }}</clr-dg-cell>
        <!-- #586806 - Update KPI Report with CP & CPK columns-->
        @if (isCpCpkSelected()) {
          <clr-dg-cell>
            @if (kpiReportDataset.cpAvg) {
              <div class="cp-layout">
                <span class="kpi {{ 'text-' | kpiLabel: kpiReportDataset.cpAvg?.kpiColor }}">
                  {{ kpiReportDataset.cpAvg?.kpiValue | number: '1.1-1' }}
                </span>
                <span>/</span>
                <span class="kpi {{ 'text-' | kpiLabel: kpiReportDataset.cpMin?.kpiColor }}">
                  {{ kpiReportDataset.cpMin?.kpiValue | number: '1.1-1' }}
                </span>
                <span>/</span>
                <span>
                  <b>{{ kpiReportDataset.cpMinAngle }}°</b>
                </span>
              </div>
            }
          </clr-dg-cell>
        }
        @if (isCpCpkSelected()) {
          <clr-dg-cell>
            @if (kpiReportDataset.cpkAvg) {
              <div class="cp-layout">
                <span class="kpi {{ 'text-' | kpiLabel: kpiReportDataset.cpkAvg?.kpiColor }}">
                  {{ kpiReportDataset.cpkAvg?.kpiValue | number: '1.1-1' }}
                </span>
                <span>/</span>
                <span class="kpi {{ 'text-' | kpiLabel: kpiReportDataset.cpkMin?.kpiColor }}">
                  {{ kpiReportDataset.cpkMin?.kpiValue | number: '1.1-1' }}
                </span>
                <span>/</span>
                <span>
                  <b>{{ kpiReportDataset.cpkMinAngle }}°</b>
                </span>
              </div>
            }
          </clr-dg-cell>
        }
      </clr-dg-row>
      <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="10">
          <clr-dg-page-size [clrPageSizeOptions]="[10, 20, 50]">Datasets per page</clr-dg-page-size>
          {{ pagination.firstItem + 1 }} - {{ pagination.lastItem + 1 }} of {{ pagination.totalItems }} datasets
        </clr-dg-pagination>
      </clr-dg-footer>
    </clr-datagrid>
  </div>
</div>
